import type { AmlLocationGeoPointEntity, CircleGeoPointEntity } from '../types';

export const convertAmlLocationGeoPointEntityToCircleGeoPointEntity = (
    amlLocationGeoPointEntity?: AmlLocationGeoPointEntity
): CircleGeoPointEntity | undefined => {
    if (!amlLocationGeoPointEntity || !amlLocationGeoPointEntity.uncertaintyRadius) {
        return undefined;
    }
    return {
        entityId: amlLocationGeoPointEntity.entityId,
        latitude: amlLocationGeoPointEntity.latitude,
        longitude: amlLocationGeoPointEntity.longitude,
        radius: amlLocationGeoPointEntity.uncertaintyRadius,
    };
};

export const getCircleSimpleFillRenderer = (color: number[]) => {
    return {
        type: 'simple', // autocasts as new SimpleRenderer()
        symbol: {
            type: 'simple-fill',
            color,
            outline: {
                width: 0,
            },
        },
        authoringInfo: undefined,
    };
};
